import RegisterComponentsContext from '../../components/register-components-context.mjs';
import ReviewsRoot from '../../components/containers/ReviewsRoot.jsx'
import LeadResponseNotice from '../../components/components/leads/LeadResponseNotice.jsx'
import PeerTalk from '../../components/components/peerTalk/PeerTalkRoot.jsx'
import LeadGen from '../../components/components/leads/LeadGen.jsx'

RegisterComponentsContext([ReviewsRoot, LeadResponseNotice, LeadGen, PeerTalk]);